import s from './modal-overlay.module.scss';
import {FC} from "react";

export const ModalOverlay: FC<{closeModal: () => void}> = ({closeModal}) => {
    return <div data-test='modal-overlay' onClick={closeModal} className={s.overlay}></div>
}

